import { render, staticRenderFns } from "./importantGene.vue?vue&type=template&id=6f90947c&scoped=true"
import script from "./importantGene.vue?vue&type=script&lang=js"
export * from "./importantGene.vue?vue&type=script&lang=js"
import style0 from "./importantGene.vue?vue&type=style&index=0&id=6f90947c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f90947c",
  null
  
)

export default component.exports